import { Endpoints } from "@/app/infrastructures/misc/Endpoints";
import { ProductEndpoint } from "@/app/infrastructures/endpoints/horde/ProductEndpoint";
import { RevenueDashboardCustomerListRequest, RevenueOverviewApiRequest, RevenueBreakdownApiRequest } from '@/domain/entities/RevenueDashboard';

export class RevenueDashboardEndpoint {
  getProductTypes(search: string, page: number, limit: number): string {
    // Use Horde ProductEndpoint to include is_no_limit=true and fetch all product types
    return new ProductEndpoint().getListProduct(search, "", page, limit, "");
  }
   getRevenueOverview(params: RevenueOverviewApiRequest) {
    return `/hydra/v1/pos-dashboard/revenue/overview?${params.toQueryString()}`
  }

  getCustomerLeaderboard(params: RevenueDashboardCustomerListRequest) {
    return `/hydra/v1/pos-dashboard/customer?${params.toQueryString()}`
  }
  getDestinationCities(search: string, page: number, limit: number): string {
    return new Endpoints().getListCity(search, "", page, limit);
  }

  getCommodities(search: string, page: number, limit: number): string {
    return new Endpoints().getCommodityListV1(search, page, limit);
  }


  getRevenueBreakdown(params: RevenueBreakdownApiRequest) {
    return `/hydra/v1/pos-dashboard/revenue/breakdown/${params.dataType}?${params.toQueryString()}`;
  }
}
